import React, { useEffect, useRef, useState } from "react";
import api from "../lib/api";
import { Store, ChevronDown, X } from "lucide-react";

export function StoreFilter({ value, onChange }) {
  const [stores, setStores] = useState([]);
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);
  useEffect(() => { api.get("/elastic/stores").then((r) => setStores(r.data || [])).catch(() => setStores([])); }, []);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h);
  }, []);
  if (stores.length < 2) return null;
  const toggle = (n) => onChange(value.includes(n) ? value.filter((x) => x !== n) : [...value, n]);
  const shown = stores.filter((s) => s.name.toLowerCase().includes(q.toLowerCase()));
  const label = value.length === 0 ? "Tutti i punti vendita" : value.length === 1 ? value[0] : `${value.length} punti vendita`;
  return (
    <div className="relative" ref={ref} data-testid="crm-store-filter">
      <button type="button" onClick={() => setOpen(!open)} data-testid="crm-store-filter-toggle" className="h-10 min-w-[220px] max-w-[320px] px-3 rounded-md bg-zinc-950 border border-zinc-800 text-xs flex items-center gap-2 hover:border-zinc-600">
        <Store className="h-3.5 w-3.5 text-[color:var(--paprika)] shrink-0" /><span className="truncate flex-1 text-left">{label}</span>
        {value.length > 0 && <X className="h-3.5 w-3.5 text-zinc-500 hover:text-zinc-200" data-testid="crm-store-filter-clear" onClick={(e) => { e.stopPropagation(); onChange([]); }} />}
        <ChevronDown className="h-3.5 w-3.5 text-zinc-500" />
      </button>
      {open && (
        <div className="absolute z-30 mt-1 w-[360px] max-w-[90vw] rounded-xl border border-zinc-800 bg-[color:var(--bg-surface)] shadow-2xl p-2 space-y-1" data-testid="crm-store-filter-menu">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca punto vendita…" className="w-full h-8 px-2 rounded-md bg-zinc-950 border border-zinc-800 text-xs" data-testid="crm-store-filter-search" />
          <div className="flex gap-2 text-[10px] text-zinc-400 px-1">
            <button type="button" onClick={() => onChange(shown.map((s) => s.name))} className="underline">Seleziona visibili</button>
            <button type="button" onClick={() => onChange([])} className="underline">Nessuno</button>
            <span className="ml-auto">{stores.length} punti vendita</span>
          </div>
          <div className="max-h-72 overflow-y-auto space-y-0.5">
            {shown.map((s) => (
              <label key={s.name} className="flex items-center gap-2 text-xs px-1 py-1 rounded hover:bg-zinc-900 cursor-pointer" data-testid={`crm-store-option-${s.name.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}>
                <input type="checkbox" className="h-3.5 w-3.5" checked={value.includes(s.name)} onChange={() => toggle(s.name)} />
                <span className="flex-1 truncate">{s.name}</span><span className="text-zinc-500 font-mono">{s.receipts.toLocaleString("it-IT")}</span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
